import { Button as AntButton, Modal } from "antd";
import { FC } from "react";
import { useTranslation } from 'react-i18next';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

const ShowRublic2Modal: FC<IProps> = ({
  visible,
  setVisible,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title="Rubric 2 Guide"
      visible={visible}
      width={750}
      onCancel={() => setVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton key="cancel" className='btn-basic gray' onClick={() => setVisible(false)}>
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <table className="table table-bordered">
        <tbody>
          <tr>
            <th className="text-center align-middle font-weight-bold">Rubric 2</th>
            <td className="text-center align-middle">Speaking</td>
            <td className="text-center align-middle">Reach Up</td>
            <td className="text-center align-middle">
              Class Debate
            </td>
            <td>
              - Content<br />
              - Discourse<br />
              - Delivery<br />
              - Participation
            </td>
          </tr>
        </tbody>
      </table>

      <table className="table table-bordered">
        <tr>
          <td />
          <th className="text-center font-weight-bold">Needs Improvement<br />1</th>
          <th className="text-center font-weight-bold">Fair<br />2</th>
          <th className="text-center font-weight-bold">Good<br />3</th>
          <th className="text-center font-weight-bold">Great<br />4</th>
          <th className="text-center font-weight-bold">Excellent<br />5</th>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Content</th>
          <td>Student’s argument is off topic. Vocabulary is far below average for the level, and grammar needs a great deal of improvement.</td>
          <td>Student’s argument is slightly off topic. Vocabulary is a little below average for the level, and grammar needs improvement.</td>
          <td>Student’s argument is somewhat on topic. Vocabulary is expected for the level, and there are some grammar errors.</td>
          <td>Student’s argument is on topic. Vocabulary is quite high for the level with very few grammar errors.</td>
          <td>Student’s argument is clearly on topic. Vocabulary is extremely high for the level with almost no grammar errors.</td>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Discourse</th>
          <td>Student’s argument lacks any organization or coherency. The supporting ideas and details are irrelevant.</td>
          <td>Student’s argument has little organization and coherency. The supporting ideas and details are slightly relevant.</td>
          <td>Student’s argument is somewhat organized and coherent/able to be followed. The supporting ideas and details are mostly relevant.</td>
          <td>Student’s argument is organized and coherent/easy to follow. The supporting ideas and details are relevant.</td>
          <td>Student’s argument is clearly organized and very coherent/easy to follow. The supporting ideas and details are relevant, and well thought-out.</td>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Delivery</th>
          <td>The student speaks with many pauses and with very unclear pronunciation. Speaking speed is very slow.</td>
          <td>The student speaks with many pauses and with unclear pronunciation. Speaking speed is slow.</td>
          <td>The student speaks with a few pauses and with somewhat unclear pronunciation. Speaking speed is somewhat slow.</td>
          <td>The student speaks naturally with fairly clear pronunciation and appropriate speed.</td>
          <td>The student speaks very naturally with clear pronunciation and appropriate speed.</td>
        </tr>
        <tr>
          <th className="align-middle font-weight-bold">Participation</th>
          <td>The student’s participation is minimal. The student needs to be continuously coerced or prompted to participate.</td>
          <td>The student participates in the debate with a little prompting from the teacher.</td>
          <td>The student participates in the debate somewhat actively.</td>
          <td>The student participates in the debate actively.</td>
          <td>The student participates in the debate very actively. No coercion or prompting is needed.</td>
        </tr>
      </table>

      <div className="border">
        • Grading Directions: Take a holistic approach when you assign a score. Consider the “average” of the student’s performance. For example, if the student demonstrates “Excellent” content, “Great” presentation, and “Good” delivery, then the student’s average would be “Great,” or a score of 4.
      </div>
    </Modal>
  );
}

export default ShowRublic2Modal;